import { formatDate, isWithinInterval } from "date-fns";

class DateTimeService {
  #value;
  #currentDate;

  constructor(value) {
    this.#value = value;
    this.#getCurrentDate();
  }

  #getCurrentDate() {
    this.#currentDate = formatDate(new Date(), "yyyy-MM-dd");
  }

  get todayDate() {
    return this.#currentDate;
  }

  get formatDate() {
    if (!this.#value) return null;
    if (typeof this.#value === "string") {
      return formatDate(new Date(this.#value), "yyyy-MM-dd"); // The format of "this.#value" should be 'yyyy-MM-dd'.
    }
    return formatDate(this.#value, "yyyy-MM-dd"); // Assume it's a Date object
  }

  get normalized() {
    if (!this.#value) return new Date(this.#currentDate);
    else return new Date(this.formatDate);
  }

  get getCurrentMonthStartDate() {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 1);
  }

  get getCurrentMonthEndDate() {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() + 1, 0);
  }

  get getPreviousMonthStartDate() {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth() - 1, 1);
  }

  get getPreviousMonthEndDate() {
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), 0);
  }

  isDateWithin(startDate, endDate) {
    const date = new Date(this.#value ? this.formatDate : this.#currentDate);
    const start = new Date(formatDate(new Date(startDate), "yyyy-MM-dd"));
    const end = new Date(formatDate(new Date(endDate), "yyyy-MM-dd"));
    return isWithinInterval(date, { start, end });
  }
}

export default DateTimeService;
